import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import api from '../api';
import {lastDateOfTheMonth} from '../utils/Month'
import headers from '../utils/headers'

const AddSchedule = () => {
    const [trainers, setTrainers] = useState([]);
    const [day, setDay] = useState(new Set());
    const [startTime, setStartTime] = useState('10:00');
    const [endTime, setEndTime] = useState('15:00');
    const [date, setDate] = useState(`${new Date().getFullYear()}-${new Date().getMonth() + 1}`);
    const [id, setId] = useState();

    useEffect(() => {
        loadTrainers();
    }, [])

    const loadTrainers = async () => {
        try {
            const {data} = await axios.get(api + '/users?role.name=trainer', {headers});
            setTrainers(data);
        } catch (err) {
            console.log(err.response);
        }
    }

    const onChecked = (e) => {
        const value = parseInt(e.target.value);
        if(day.has(value)){
            day.delete(value);
        } else {
            day.add(value);
        }
    }

    const CreateTrainer = async (day) => {
        const reqData = {
            start_time: startTime + ':00.000',
            end_time: endTime + ':00.000',
            day: day,
            effective_date: date + '-01',
            expiry_date: lastDateOfTheMonth(new Date(date)),
            trainer: id
        }
        try {
            const {data} = await axios.post(api + '/schedules', reqData, {headers});
            window.location.href = '/trainer-schedules'
        } catch (err) {
            console.log(err.response);
        }
    }

    const initCreateTrainer = (e) => {
        e.preventDefault();
        day.forEach(day => {
            CreateTrainer(day);
        })
    }

    return (
        <React.Fragment>
        <Form style={{width: '100%'}} onSubmit={initCreateTrainer}>
            <div className="container-fluid">
                <Row>
                    <Col>
                        <div className="single-activity-header">
                            <h3 className="dash-title">Add Trainer Schedule</h3>
                            <div className="add-emp-btn-group">
                                <button className="employee-add-btn" type="submit">
                                    Save
                                </button>
                                <Link className="employee-add-btn cancel" to="/trainer-schedules">
                                    Cancel
                                </Link>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="container-fluid dashboard-wrapper white-wrapper daily-activity-table">
                <Row>
                    <Form.Group as={Row} className="emp-form-row">
                        <Col>
                            <Form.Label>Trainer</Form.Label>
                            <Form.Control as="select" onChange={(e) => setId(e.target.value)}>
                                <option value="">Select Trainer</option>
                                {trainers.map(( trainer ) => (
                                    <option value={trainer.trainer.id} key={trainer.id}>{trainer.trainer.name} #{trainer.username}</option>
                                ))}
                            </Form.Control>
                        </Col>
                        <Col>
                            <Form.Label>Day</Form.Label><br/>
                            <div key="inline-checkbox">
                                <Form.Check inline label="Sunday" value={0} onChange={onChecked} type="checkbox" id={`inline-checkbox-1`} />
                                <Form.Check inline label="Monday" value={1} onChange={onChecked} type="checkbox" id={`inline-checkbox-2`} />
                                <Form.Check inline label="Tuesday" value={2} onChange={onChecked} type="checkbox" id={`inline-checkbox-3`} />
                                <Form.Check inline label="Wednesday" value={3} onChange={onChecked} type="checkbox" id={`inline-checkbox-4`} />
                                <Form.Check inline label="Thursday" value={4} onChange={onChecked} type="checkbox" id={`inline-checkbox-5`} />
                                <Form.Check inline label="Friday" value={5} onChange={onChecked} type="checkbox" id={`inline-checkbox-6`} />
                                <Form.Check inline label="Saturday" value={6} onChange={onChecked} type="checkbox" id={`inline-checkbox-7`} />
                            </div>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="emp-form-row">
                        <Col>
                            <Form.Label>Start Time</Form.Label><br/>
                            <input style={{width: '100%', height: '40px', paddingLeft: '5px'}}  type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)}/>
                        </Col>
                        <Col>
                            <Form.Label>End Time</Form.Label><br/>
                            <input style={{width: '100%', height: '40px', paddingLeft: '5px'}}  type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)}/>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="emp-form-row">
                        <Col>
                            <Form.Label>Select Month</Form.Label><br/>
                            <input style={{width: '100%', height: '40px', paddingLeft: '5px'}} type="month" value={date} onChange={(e) => setDate(e.target.value)} />
                        </Col>
                    </Form.Group>
                </Row>
            </div>
        </Form>
        </React.Fragment>
    )
}

export default AddSchedule